import Vue from 'vue';
import VeeValidate from 'vee-validate';
import messagesEs from '../shared/vendor/validation-locales/es';
import messagesMk from '../shared/vendor/validation-locales/mk';
import store from '../shared/vuex/store';
import Header from './components/Header.vue';

Vue.use(VeeValidate, {
    locale: 'en',
    delay: 500,
    dictionary: {
        es: {
            messages: messagesEs,
        },
        mk: {
            messages: messagesMk,
        },
    },
});

if (document.getElementById('header-app')) {
    new Vue({
        el: '#header-app',
        store,
        render: (h) => h(Header),
    });
}
